import followService from '../services/followService';
import { createOrGetMatrixRoom, deleteMatrixRoom } from './matrixAction';
import { store } from '../store';
import { DISCOVER_ACTION_TYPES } from './types';

/**
 * Sync discover follow status to Redux store
 * @param {string} creatorId - Creator ID to sync
 * @param {boolean} isFollowing - Whether the creator is followed
 */
const syncDiscoverFollowStatus = (creatorId, isFollowing) => {
  if (!creatorId) return;
  store.dispatch({
    type: DISCOVER_ACTION_TYPES.UPDATE_FOLLOW_STATUS,
    payload: { creatorId, isFollowing },
  });
};

/**
 * Follow a PPV creator (without dispatch)
 * @param {string} creatorId - Creator ID to follow
 * @returns {Promise<Object>} Follow result
 */
export const followPPV = async (creatorId) => {
  try {
    if (!creatorId) {
      return { success: false, error: 'Creator ID is required' };
    }

    const response = await followService.followPPVCreator(creatorId);
    
    if (response.success) {
      // create or get matrix room for creator if followed
      try {
        await createOrGetMatrixRoom(creatorId);
      } catch (_) {}

      syncDiscoverFollowStatus(creatorId, true);
      
      return { success: true, data: response.data, message: response.message };
    } else {
      return { success: false, error: response.message || 'Failed to follow creator' };
    }
  } catch (error) {
    return { 
      success: false, 
      error: error.message || 'An unexpected error occurred',
      status: error.status
    };
  }
};

/**
 * Unfollow a PPV creator (without dispatch)
 * @param {string} creatorId - Creator ID to unfollow
 * @returns {Promise<Object>} Unfollow result
 */
export const unfollowPPV = async (creatorId) => {
  try {
    if (!creatorId) {
      return { success: false, error: 'Creator ID is required' };
    }

    const response = await followService.unfollowPPVCreator(creatorId);

    if (response.success) {
      // delete matrix room for creator if unfollowed
      // const roomId = response?.data?.roomId;
      // if (roomId) {
      //   try {
      //     await deleteMatrixRoom(roomId);
      //   } catch (_) {}
      // }

      syncDiscoverFollowStatus(creatorId, false);

      return { success: true, data: response.data, message: response.message };
    } else {
      return { success: false, error: response.message || 'Failed to unfollow creator' };
    }
  } catch (error) {
    return { 
      success: false, 
      error: error.message || 'An unexpected error occurred',
      status: error.status
    };
  }
};

/**
 * Fetch one page of followers or subscribers (without dispatch)
 * @param {string} creatorId - Creator ID to fetch followers for
 * @param {{ skip?: number, limit?: number, search?: string }} [params]
 * @returns {Promise<Object>} Followers page plus pagination
 */
export const fetchFollowersList = async (creatorId, params = {}) => {
  try {
    if (!creatorId) {
      return { success: false, error: 'Creator ID is required' };
    }

    const response = await followService.fetchFollowersList(creatorId, params);

    if (response.success) {
      return {
        success: true,
        data: response.data,
        pagination: response.pagination || null,
        message: response.message,
      };
    } else {
      return { success: false, error: response.message || 'Failed to fetch followers list' };
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || 'An unexpected error occurred',
      status: error.status
    };
  }
};

